import {Component, Input, OnInit, ChangeDetectorRef} from '@angular/core';
import {ActivityFeedModel} from '../../../DataModels/activity-feed-model';
import {DataService} from '../../../Services/data.service';
import {Observable} from 'rxjs';
import {DateFilterService} from '../../../Services/dateFilter.service';
import {AppConfigService} from '../../../Services/app-config.service';
import {RecentActivity} from '../widget/recent-activity/recent-activity.model';
import {CardDropdownOption} from '../widget/card-title/card-title.model';
import { BsToastService} from '../../../Services/bs-toast-service';
import {EmailModel} from '../../../DataModels/email-model';
import {Modal} from 'bootstrap';

@Component({
  selector: 'app-activity-feed',
  templateUrl: './activity-feed.component.html',
  styleUrls: ['./activity-feed.component.css'],
  standalone: false
})
export class ActivityFeedComponent implements OnInit {
  // @Input() recentActivities: RecentActivity[] = [];
  @Input() height = 0;
  @Input() activityEntityID: string;
  vm: any = {
    toDate: Date,
    fromDate: Date
  };

  activity: Observable<ActivityFeedModel[]>;
  newMessage;
  lastActivityDate: any;
  dropdownOptions: CardDropdownOption[] = [];
  recentActivities: RecentActivity[] = [];
  recentActivitiesSave: RecentActivity[] = [];
  searchText: string;
  emailObject: EmailModel;

  constructor(private table: DataService,
              private dateFilter: DateFilterService,
              private appConfigService: AppConfigService,
              private notificationService: BsToastService,
              private cdr: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.vm.DataFormat = 'MM-DD-YYYY';
    this.vm.addNewFeed = false;
    this.vm.searchFeed = false;

    // set default dates for startup
    let from: any = new Date();
    let to: any = new Date(Date.now());

    // from = to - days in config
    from.setDate(to.getDate() - this.appConfigService.activityFeedDays);


    // format date fields for picker
    to = this.dateFilter.GetDateFormat(to);
    from = this.dateFilter.GetDateFormat(from);

    // now set vars for template use
    this.vm.toDate = to;
    this.vm.fromDate = from;

    this.vm.feedFilter = '';
    this.vm.ActivityFeed = {};
    this.vm.ActivityFeed.location = [];
    this.vm.ActivityFeed.company = [];
    // this.entityId = '';
    this.dropdownOptions = [
      {
        label: 'Print',
        icon: 'bi bi-printer-fill',
        action: () => this.printActivity()
      },
      {
        label: 'Email',
        icon: 'bi bi-envelope',
        action: () => this.emailActivity()
      }
    ];
    this.loadActivity();
  }

  refreshData() {
    this.notificationService.showSuccessToast('Feed Updated');
    this.loadActivity();
  }
  loadActivity() {

    this.vm.ActivityFeed = null;

    // so sql likes date format - datetime field in sql so set midnight by pushing forward a day on to
    const tempDate = new Date(Date.now());
    tempDate.setDate( tempDate.getDate() + 1 );

    const sqlToDate = this.dateFilter.GetDateFormat(tempDate, 'yyyy-MM-dd');
    const sqlFromDate = this.dateFilter.GetDateFormat(this.vm.fromDate, 'yyyy-MM-dd');

    const urlParams = {
      fromDate: sqlFromDate,
      toDate: sqlToDate,
      search: this.vm.feedFilter,
      entity_id: this.activityEntityID
    };

    // console.log('params: ' + JSON.stringify(urlParams));

    const params: string = this.encodeQueryData(urlParams);

    this.table.getData('activityfeed/GetActivityFeedByDate', '?' + params).subscribe((result: any[]) => {
      this.vm.ActivityFeed = [];
      this.recentActivities = [];
      this.vm.ActivityFeed = result;
      // console.log('af',result);
      this.assignIcons(this.vm.ActivityFeed);
    });
  }

  assignIcons(data: any) {
    data.forEach((currentValue, index) => {

      let icon = '';
      const checkVal = currentValue.batch_type_id;
      // console.log(checkVal);
      switch (checkVal) {
        // journal entry
        case 1 : {
          icon = 'mdi mdi-receipt text-success';
          break;
        }
        // ar sales invoice
        case 2: {
          icon = 'mdi mdi-currency-usd text-success';
          break;
        }
        // ar payment / receipt
        case 3: {
          icon = 'mdi mdi-currency-usd text-success';
          break;
        }
        // payable invoice
        case 4: {
          icon = 'mdi mdi-currency-usd text-success';
          break;
        }
        // payable payment
        case 5: {
          icon = 'mdi mdi-cash-refund text-success';
          break;
        }
        // budget
        case 6: {
          icon = 'mdi mdi-airplane text-success';
          break;
        }
        // ap payment
        case 7: {
          icon = 'mdi mdi-currency-usd text-success';
          break;
        }
        // quote
        case 8: {
          icon = 'mdi mdi-currency-usd text-success';
          break;
        }
        // sales order
        case 9: {
          icon = 'mdi mdi-currency-usd text-success';
          break;
        }
        // purchase order
        case 10: {
          icon = 'mdi mdi-currency-usd text-success';
          break;
        }
        // inventory adjustment
        case 13: {
          icon = 'bi bi-basket text-success';
          break;
        }
        // work order
        case 18: {
          icon = 'mdi mdi-currency-usd text-success';
          break;
        }
        // email
        case 97: {
          icon = 'mdi mdi-cash-register text-success';
          break;
        }
        // other and POS
        case 99: {
          icon = 'mdi mdi-cash-register text-success';
          break;
        }
        // inventory count
        case 130: {
          icon = 'bi bi-basket text-success';
          break;
        }
        default: {
          icon = 'mdi mdi-crosshairs-question text-danger';
          break;
        }
      }
      this.recentActivities.push({
        id: currentValue.id,
        title: currentValue.user_name,
        timelineIcon: icon,
        variant: 'primary',
        text: currentValue.message,
        mainText: currentValue.batch_name,
        time: currentValue.ActivityDate,
        company_name: currentValue.company_name,
        batch_type_id: currentValue.batch_type_id,
        location_name: currentValue.location_name,
        entity_name: currentValue.entity_name,
        detail_total: currentValue.detail_total,
        header_id: currentValue.header_id,
        message: currentValue.message,
        number: currentValue.number,
        user_name: currentValue.user_name,
        batch_name: currentValue.batch_name
      });
    });
    this.recentActivitiesSave = this.recentActivities;
    // console.log(this.recentActivitiesSave);
  }

  filterActivity() {
    if (this.searchText == '') {
      this.recentActivities = this.recentActivitiesSave;
    } else {
      const searchTerm = this.searchText.toLowerCase();
      this.recentActivities = this.recentActivities.filter(activity => {
        // return activity.location_name.toLowerCase().includes(searchTerm ) ||
        if (searchTerm !== '') {
          return activity.location_name?.toLowerCase().includes(searchTerm) ||
            activity.message?.toLowerCase().includes(searchTerm) ||
            activity.mainText?.toLowerCase().includes(searchTerm) ||
            activity.number?.toLowerCase().includes(searchTerm) ||
            activity.entity_name?.toLowerCase().includes(searchTerm) ||
            activity.company_name?.toLowerCase().includes(searchTerm) ||
            activity.user_name?.toLowerCase().includes(searchTerm) ||
            // TODO activity.detail_total?.toLowerCase().includes(searchTerm) ||
            activity.text?.toLowerCase().includes(searchTerm) ||
            activity.batch_name?.toLowerCase().includes(searchTerm) ||
            activity.number?.toLowerCase().includes(searchTerm) ||
            activity.title?.toLowerCase().includes(searchTerm) ||
            activity.detail_total?.toString().toLowerCase().includes(searchTerm);
        }

        });
      // this.employeeList = this.filteredEmployees;
    }
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      } else if (data[d] != null && data[d] == '') {
        ret.push(encodeURIComponent(d) + '=');
      }
    }
    return ret.join('&');
  }

  printActivity() {
    const html = this.buildActivityFeedHtml(false);
    this.printHtmlInIframe(html);
  }

  async emailActivity() {
    try {
      const fromStr = this.vm.fromDate ? new Date(this.vm.fromDate).toLocaleDateString() : '';
      const toStr = this.vm.toDate ? new Date(this.vm.toDate).toLocaleDateString() : '';
      const dateRangeStr = (fromStr || toStr) ? ` (${fromStr} - ${toStr})` : '';

      const html = this.buildActivityFeedHtml(true);
      const emailDocObj = {} as EmailModel;
      const emailDocumentName = 'Activity Feed';
      emailDocObj.print_orientation = '1';
      emailDocObj.convert_attachment_to = 'pdf';
      emailDocObj.fromEmail = '';
      emailDocObj.fromName = 'AcctXErp';
      emailDocObj.header_id = null as any;
      emailDocObj.toEmail = '';
      emailDocObj.body = 'Please see the attached ' + emailDocumentName + dateRangeStr + '.<br><br><br>'
        + 'Best regards,'
        + '<br><br>'
        + 'AcctXErp'
        + '<br><br>';
      emailDocObj.Subject = 'AcctXErp ' + emailDocumentName + dateRangeStr;
      emailDocObj.activity_message = emailDocumentName;
      emailDocObj.pdfHtml = html || '';

      const safeName = (emailDocumentName || 'document').replace(/\s+/g, '_');
      emailDocObj.FileName = `${safeName}.pdf`;

      this.emailObject = emailDocObj;
      this.cdr.detectChanges();

      const emailEl = document.getElementById('sendEmailModal');
      const modal = emailEl ? Modal.getOrCreateInstance(emailEl) : null;
      modal?.show();
    } catch (e) {
      console.error('Activity Feed prepare email failed', e);
      this.notificationService.showErrorToast('Unable to prepare email for Activity Feed');
    }
  }

  private buildActivityFeedHtml(forEmail: boolean = false): string {
    const list = this.recentActivities || [];
    const fromStr = this.vm.fromDate ? new Date(this.vm.fromDate).toLocaleDateString() : 'N/A';
    const toStr = this.vm.toDate ? new Date(this.vm.toDate).toLocaleDateString() : 'N/A';

    const rows = list.map((af: any) => {
      const dt = af?.time ? new Date(af.time) : null;
      const dtStr = dt ? dt.toLocaleString() : '';
      const user = af?.user_name || '';
      const msg = af?.message || '';
      const batch = af?.batch_name || '';
      const num = af?.number || '';
      return `<tr><td>${dtStr}</td><td>${this.escapeHtml(user)}</td><td>${this.escapeHtml(batch)} ${this.escapeHtml(num)}</td><td>${this.escapeHtml(msg)}</td></tr>`;
    }).join('');

    const styles = `
      <style>
        @page { size: landscape; margin: 12mm; }
        @media print { .no-print { display: none !important; } }
        body { font-family: Arial, Helvetica, sans-serif; margin: 24px; }
        h1 { font-size: 18px; margin: 0 0 8px 0; }
        .meta { font-size: 12px; color: #555; margin-bottom: 8px; }
        .meta span { display: inline-block; margin-right: 16px; }
        table { width: 100%; border-collapse: collapse; margin-top: 12px; }
        th, td { border: 1px solid #ccc; padding: 6px 8px; font-size: 12px; }
        th { background: #f6f6f6; text-align: left; }
      </style>
    `;

    const title = 'Activity Feed';
    const runAt = new Date().toLocaleString();

    return `
      <html>
        <head>
          <meta charset="utf-8" />
          <title>${title}</title>
          ${styles}
        </head>
        <body>
          <h1>${title}</h1>
          <div class="meta">
            <span><strong>From:</strong> ${this.escapeHtml(fromStr)}</span>
            <span><strong>To:</strong> ${this.escapeHtml(toStr)}</span>
            <span><strong>Run:</strong> ${this.escapeHtml(runAt)}</span>
            <span><strong>Count:</strong> ${list.length}</span>
          </div>
          <table>
            <thead>
              <tr><th>Date Time</th><th>User Name</th><th>Reference</th><th>Activity</th></tr>
            </thead>
            <tbody>
              ${rows}
            </tbody>
          </table>
          ${!forEmail ? '<div class="no-print" style="margin-top:16px"><button onclick="window.print()">Print</button></div>' : ''}
        </body>
      </html>
    `;
  }

  private printHtmlInIframe(html: string): void {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.setAttribute('aria-hidden', 'true');

    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) {
      this.notificationService.showErrorToast('Unable to access print frame');
      document.body.removeChild(iframe);
      return;
    }

    doc.open();
    doc.write(html);
    doc.close();

    const printAndCleanup = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      } finally {
        setTimeout(() => {
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
        }, 1000);
      }
    };

    if (doc.readyState === 'complete') {
      setTimeout(printAndCleanup, 250);
    } else {
      iframe.onload = () => setTimeout(printAndCleanup, 250);
    }
  }

  private escapeHtml(text: string): string {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}
